import { AccessTokenStore } from './accessTokenStore';
import { refreshAccessToken } from './refreshAccessToken';
export const isAuthenticated = async (walletAddress) => {
    if (AccessTokenStore.getInstance().isAuthenticated(walletAddress))
        return true;
    // we cannot read the refresh cookie, so we have to ask the server if we have a valid cookie.
    const response = await refreshAccessToken(walletAddress);
    return response.success;
};
